/**
 * Payments / billing boundary.
 *
 * The game NEVER talks to a payment provider directly. It only asks this
 * boundary: "what does this player own / is this player subscribed?" and (from
 * the shop UI) "purchase / subscribe / restore". This abstracts over the things
 * that differ between providers — one-time purchases, subscriptions (for the
 * ad-free tier), restoring purchases, and entitlement queries — so a real
 * provider (Stripe, app-store IAP, ...) can be implemented behind it later
 * without touching game or UI code.
 *
 * Product ids the rest of the app references:
 *   - PRODUCT_AD_FREE  : one-time (or substitute a subscription plan id)
 *   - PLAN_AD_FREE_SUB : subscription tier that also grants ad-free
 *   - skin ids from the skins catalog
 */
export const PRODUCT_AD_FREE = 'ad_free';
export const PLAN_AD_FREE_SUB = 'ad_free_monthly';

export interface Entitlements {
  /** Player should not be shown ads. */
  adFree: boolean;
  /** Skin ids the player owns. */
  ownedSkins: string[];
  /** Active subscription plan ids. */
  subscriptions: string[];
}

export interface PurchaseResult {
  ok: boolean;
  productId: string;
  error?: string;
}

export interface BillingService {
  /** Whether real billing is active (FEATURES.payments). */
  isEnabled(): boolean;
  getEntitlements(): Promise<Entitlements>;
  ownsProduct(productId: string): Promise<boolean>;
  isSubscribed(planId: string): Promise<boolean>;
  purchase(productId: string): Promise<PurchaseResult>;
  subscribe(planId: string): Promise<PurchaseResult>;
  restorePurchases(): Promise<Entitlements>;
}

export function emptyEntitlements(): Entitlements {
  return { adFree: false, ownedSkins: [], subscriptions: [] };
}
